<template>
	<div class="studios-carousel">
		<div class="container">
			<div class="carousel-bottom">
				<div class="row">
					<div class="col-md-6">
						<swiper
							class="swiper" :options="swiperOptionThumbs" ref="swiperThumbs"
						>
							<swiper-slide v-for="(studio, index) in studios" class="studios-carousel__thumb element" :class="`slide-${index}`" :key="index">
								<div class="slide-wrapper">
									<div class="image">
										<img loading="lazy" :src="`${studio.thumbnail}`" :title="studio.title" :alt="studio.title">
									</div>
								</div>
							</swiper-slide>
						</swiper>

						<div class="swiper-button-prev" slot="button-prev" id="swiper-prev-studios">
						<svg class="ticon ticon-180"><use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use></svg>
						</div>
						<div class="swiper-button-next" slot="button-next" id="swiper-next-studios">
							<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-arrow-right"></use></svg>
						</div>

					</div>
				</div>
			</div>

			<div class="carousel-main">
				<swiper
					ref="swiperFull" :options="swiperOptions" class="swiper"
				>
					<swiper-slide v-for="(studio, index) in studios" class="studios-carousel__slide" :class="`slide-${index}`" :key="index">
						<div class="row slide-wrapper">
							<div class="col-12 col-md-6 image">
								<img class="img-fluid" :src="`${studio.picture}`" title="Studio" :alt="studio.title">
							</div>
							<div class="col-12 col-md-6 content">
								<div class="row">
									<div class="content-container">
										<div class="content-wrapper">
											<div class="number">{{ index + 1 }} / {{ studios.length }}</div>
											<h3 v-text="studio.title"></h3>
											<p v-text="studio.location"></p>
											<div v-if="studio.website || studio.facebook_profile || studio.instagram_profile" class="network">
												<span v-text="$__('strings.text.visit.site')"></span>
												<a v-if="studio.website" :href="studio.website" class="website" title="Website" rel="nofollow" target="_blank">
													<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-globe"></use></svg>
												</a>
												<a v-if="studio.facebook_profile" :href="studio.facebook_profile" class="fb" title="Facebook" rel="nofollow" target="_blank">
													<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-facebook"></use></svg>
												</a>
												<a v-if="studio.instagram_profile" :href="studio.instagram_profile" class="ig" title="Instagram" rel="nofollow" target="_blank">
													<svg class="ticon"><use xlink:href="/images/icons.svg?v1.3#icon-instagram"></use></svg>
												</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</div>
	</div>
</template>

<script>

import { Swiper, SwiperSlide } from 'vue-awesome-swiper'

export default {
	name: 'StudiosCarousel',
	components: {
		Swiper,
		SwiperSlide
	},
	props: {
		studios: Array
	},
	data() {
		return {
			swiperOptionThumbs: {
				loop: true,
				loopedSlides: 5, // looped slides should be the same
				slidesPerView: 'auto',
				// spaceBetween: 44,
				centeredSlides: true,
				slideToClickedSlide: true,
				touchRatio: 0.5,
				navigation: {
					nextEl: '#swiper-next-studios',
					prevEl: '#swiper-prev-studios'
				}

			},
			swiperOptions: {
				loop: true,
				loopedSlides: 5, // looped slides should be the same
			}
		}
	},
	mounted() {
		this.$nextTick(() => {
			const swiperFull = this.$refs.swiperFull.$swiper;
			const swiperThumbs = this.$refs.swiperThumbs.$swiper;
			swiperFull.controller.control = swiperThumbs;
			swiperThumbs.controller.control = swiperFull;
		})
	}
}

</script>
